export enum StatusCode {
  NetworkError = 461,
  SchemaParseError = 520,
  Timeout = 408,
  UnknownError = 460,
}
